import { Button, SVG } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

import { SubTopicObject } from "assets/data/topics";

export type TopicsModalProps = CustomComponentProps & {
    opened: boolean;
    closeModal: React.Dispatch<React.SetStateAction<boolean>>;
    selectedTopics: SubTopicObject[];
    toggleTopic: Function;
    title: string;
    subTopics: SubTopicObject[];
};

const TopicsModal = ({
    opened,
    closeModal,
    selectedTopics,
    toggleTopic,
    title,
    subTopics,
    className,
    style
}: TopicsModalProps) => {
    return (
        <div
            className={`modal share-modal is-xsmall has-light-bg ${opened ? "is-active" : ""} ${className}`}
            style={style}
        >
            <div className="modal-background"></div>
            <div className="modal-content">
                <div className="card">
                    <div className="card-heading flex-a-start">
                        <div>
                            <h3> {title} </h3>
                        </div>

                        {/* <!-- Close X button --> */}
                        <div className="close-wrap">
                            <span
                                className="close-modal"
                                onClick={() => closeModal(false)}
                            >
                                <SVG
                                    svg="x"
                                    size={16}
                                    className="light-grey-svg"
                                />
                            </span>
                        </div>
                    </div>

                    <div className="card-body">
                        <ul className="ks-cboxtags topic-body d-flex flex-wrap flex-j-start gap-5">
                            {subTopics.map((topic) => (
                                <li
                                    key={topic.SubTopicId}
                                    className={
                                        selectedTopics.includes(topic)
                                            ? "checked"
                                            : ""
                                    }
                                    onClick={() => toggleTopic(topic)}
                                >
                                    <label>{topic.Name}</label>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="card-footer d-flex flex-j-end">
                        <div className="button-wrap">
                            <Button
                                text="close"
                                className="dark-grey-button close-modal"
                                handleClick={() => closeModal(false)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopicsModal;
